import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

const NoPayments: React.FC = () => {
  const location = useLocation();
  const { name, institution } = location.state || { name: '', institution: '' };

  return (
    <Box sx={{ textAlign: 'center', marginTop: 8, padding: 4 }}>
      <Typography variant="h4" sx={{ color: '#2e7d32', fontWeight: 'bold', marginBottom: 2 }}>
        שלום וברכה
      </Typography>
      <Typography variant="h6" sx={{ color: '#333' }}>
        תשלום ההסעות עבור התלמיד <strong>{name}</strong><br />
        שבמוסד <strong>{institution}</strong> הוסדר
      </Typography>
      <Typography variant="h6" sx={{ color: '#333', marginTop: 2 }}>
        אין חוב למערכת
      </Typography>
      <Typography variant="h6" sx={{ color: '#333', marginTop: 2 }}>
        פרטים על מיקום התחנה ושעת ההגעה של ההסעה יישלחו לקראת פתיחת שנת הלימודים
      </Typography>
    </Box>
  );
};

export default NoPayments;
